
export class AgGridUtility {

  constructor() {}

  formatDates(params) {
    if(!params.value){
      return null;
    }

    const dateParts = params.value.split('/');
    const day = dateParts[2];
    const month = dateParts[1];
    const year = dateParts[0];
    return month + '/' + day + '/' + year;   
  }

  formatDobDates(params) {
    if(!params.value){
      return null;
    }

    const dateParts = params.value.split('/');
    const year = dateParts[2];
    const day = dateParts[1];
    const month = dateParts[0];
    return month + '/' + day + '/' + year;   
  }

  formatTimeDateToDate(params) {
    if(!params.value){
      return null;
    }

    const dateStr = (params.value.split("T"))[0];
    const dateParts = dateStr.split('/');
    const day = dateParts[2];
    const month = dateParts[1];
    const year = dateParts[0];
    return month + '/' + day + '/' + year;
  }

  formatDateCol(params) {
    if(!params.value){
      return `N/A`;
    }

    const dateStr = (params.value.split("T"))[0];
    const dateParts = dateStr.split('/');
    const day = dateParts[2];
    const month = dateParts[1];
    const year = dateParts[0];
    return month + '/' + day + '/' + year;
  }

  formatTimeDateToDateTime(params) {
    if(!params.value){
      return null;
    }

    const dateStr = (params.value.split("T"))[0];
    const timeStr= (params.value.split("T"))[1]
    const dateParts = dateStr.split('/');
    const day = dateParts[2];
    const month = dateParts[1];
    const year = dateParts[0];

    let mer;
    const timeParts = timeStr.split(':');

    let hours = timeParts[0];
    const min  = timeParts[1];
    const sec = timeParts[2];

    let hoursInt = parseInt(hours);
    if ( hoursInt > 12 ){
      hoursInt = hoursInt -12;
      if(hoursInt<10){
        hours = '0' + hoursInt;
      }
      else{
        hours = hoursInt;
      }
      mer = 'PM';

    }else {
      mer = 'AM';
    }

    return month + '/' + day + '/' + year +' ' + hours + ':' + min + ' '+ mer  ;
  }

  formatDateToMonthAndYear(params) {
    if(!params.value){
      return null;
    }

    const dateStr = (params.value.split("T"))[0];
    const dateParts = dateStr.split('/');
    const day = dateParts[2];
    const month = dateParts[1];
    const year = dateParts[0];
    return month + '/'  + year;
  }

  filterDates(filterLocalDateAtMidnight, cellValue) {
    if(!cellValue){
      return;
    }

    // We create a Date object for comparison against the filter date
    const dateStr = (cellValue.split("T"))[0];
    console.log(dateStr)
    const dateParts = dateStr.split("/");
    const day = Number(dateParts[2]);
    const month = Number(dateParts[1]) - 1;
    const year = Number(dateParts[0]);
    const cellDate = new Date(year, month, day);

    if (cellDate < filterLocalDateAtMidnight) {
      return -1;
    } else if (cellDate > filterLocalDateAtMidnight) {
      return 1;
    } else {
      return 0;
    }
  }

  filterMonthYear(filterLocalDateAtMidnight, cellValue) {
    if(!cellValue){
      return;
    }

    // We create a Date object for comparison against the filter date
    const dateStr = (cellValue.split(" "))[0];
    const dateParts = dateStr.split("/");
    const day = Number(1);
    const month = Number(dateParts[1]) - 1;
    const year = Number(dateParts[0]);
    const cellDate = new Date(year, month, day);
    const dateFilter = new Date(filterLocalDateAtMidnight);
    dateFilter.setDate(1);

    if (cellDate < dateFilter) {
      return -1;
    } else if (cellDate > dateFilter) {
      return 1;
    } else {
      return 0;
    }
  }

  formatSsn(params){
    if(!params.value){
      return '';
    }

    const ssn = params.value;
    //const ssnFormatted = ssn.substring(0,3) + '-' + ssn.substring(3,5) + '-' + ssn.substring(5);
    const ssnFormatted = 'XXX-XX-' + ssn.substring(5);
    return ssnFormatted;
  }

  formatPhoneNumber(params) {
    if(!params.value){
      return '';
    }

    const phoneNumber = params.value;
    const formattedPhoneNumber = phoneNumber.substring(0, 3) + '-' + phoneNumber.substring(3, 6) + '-' + phoneNumber.substring(6, 10);
    return formattedPhoneNumber;
  }

  formatAmount(params){
    if(params.value === null || params.value === undefined){
      return '';
    }

    const amount = params.value + '';
    let cents = amount.split('.')[1];
    let amountFormatted;

    if(cents !== null && cents !== undefined){
      if(cents.length === 0){
        cents = '00';
      } else if(cents.length === 1){
        cents += '0';
      }
    } else {
      cents = '00';
    }
    amountFormatted =  '$' + amount.split('.')[0] + '.' + cents;
    return amountFormatted;
  }

  formatDateValue(value) {
    if(!value){
      return '';
    }

    const dateParts = value.split('/');
    const day = dateParts[2];
    const month = dateParts[1];
    const year = dateParts[0];
    return month + '/' + day + '/' + year;
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/Utility/AgGridUtility.ts